import React from 'react';
import { PieChart, Pie, Legend, Tooltip, Cell } from 'recharts';

// const COLORS = ["#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9",
//                 "#FFDC00", "#001f3f", "#39CCCC", "#01FF70", "#85144b", "#F012BE",
//                 "#3D9970", "#111111", "#AAAAAA"];
// const COLORS = ["#08FF4F", "#FFDC08", "#FF06B8", "#0826FF", "#6FFF07", "#FD1507",
//                 "#9B06FE", "#08EFF8", "#DCFE07", "#FE386D", "#C15AFF", "#5AFFD7"]
const COLORS = [
  '#FFF35F',
  '#74A9BB',
  '#0489A8',
  '#0570A6',
  '#494965',
  '#37384D',
  '#E52C65',
  '#EE534F',
  '#FF9051',
  '#FCAC00',
  '#FFC851',
];

const AnalyticsPieChart = ({ dataset, width, height }) => {
  if (!dataset || !dataset.length) {
    return null;
  }
  const total = dataset.reduce((acc, item) => {
    acc += item.value;
    return acc;
  }, 0);
  const formatterFunc = (value) => {
    const inPercentage =
      Math.round((parseFloat(value) / total) * 100 * 100) / 100;
    return `${value} (${inPercentage}%)`;
  };

  return (
    <PieChart width={width} height={height}>
      <Pie
        dataKey="value"
        isAnimationActive={false}
        data={dataset}
        cx="50%"
        cy="50%"
        outerRadius={100}
        fill="#8884d8"
      >
        {dataset.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip formatter={formatterFunc} />
      <Legend verticalAlign="bottom" align="center" />
    </PieChart>
  );
};

export default AnalyticsPieChart;
